<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Dữ liệu SMS</h1>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.timeCount"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
        <h4 v-if="countSms !== null">Tổng số SMS: {{ countSms }}</h4>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  import moment from 'moment'
  import { CommonService } from '../../services/common.service'
  export default {
    name: 'data-sms',
    data() {
      return {
        Config,
        showLoading: false,
        countSms: null,
        search: {
          timeCount: {},
        },
      }
    },
    methods: {
      preareData() {
        const data = cloneDeep(this.search)
        if (data.timeCount.endDate) {
          data.startDate = moment(data.timeCount.startDate).startOf('day').valueOf()
          data.endDate = moment(data.timeCount.endDate).endOf('day').valueOf()
        }
        delete data.timeCount
        return data
      },
      removeForm() {
        this.search = {
          timeCount: {
            startDate: null,
            endDate: null,
          },
        }
        this.countSms = null
      },
      async submitForm() {
        try {
          this.showLoading = true
          const params = this.preareData()
          const response = await CommonService.countDataSms(params)
          if (response.code === 1000) {
            this.countSms = response.data
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
